import { createActions } from "redux-actions";

const { login, loginSuccess, loginFailure, loginIdle } = createActions(
  "LOGIN",
  "LOGIN_SUCCESS",
  "LOGIN_FAILURE",
  "LOGIN_IDLE"
);

export { login, loginSuccess, loginFailure, loginIdle };
